import isEmpty from 'lodash.isempty';
import {
    fetchUserAttributes,
    selectUserAttributes
} from '@components/Login/userSlice';
import usePrefetchOnIdle from './usePrefetchOnIdle';

const PREFETCHERS = [
    {
        name: 'userAttributes',
        action: () => fetchUserAttributes(),
        shouldFetch: (state) => isEmpty(selectUserAttributes(state))
    }
];

export default function useSenderPrefetch({enabled}) {
    usePrefetchOnIdle(PREFETCHERS, {enabled, delay: 1000});
}
